import React, { useEffect, useState } from 'react';
import { Smartphone, Loader, Check } from 'lucide-react';
import authService from '../../services/authService';
import { debugError } from '../../utils/logger';

// Editor del número de Nequi del médico en la pestaña "Perfil".
// Carga el valor actual desde /auth/me y lo actualiza vía PUT /auth/nequi.
function NequiEditor() {
  const [nequiNumber, setNequiNumber] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await authService.getMe();
        if (mounted) setNequiNumber(res?.data?.user?.nequiNumber || '');
      } catch (err) {
        debugError('Error cargando número de Nequi:', err);
        if (mounted) setError('No se pudo cargar tu número de Nequi');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const handleChange = (e) => {
    setNequiNumber(e.target.value.replace(/\D/g, '').slice(0, 10));
  };

  const handleSave = async () => {
    if (!/^\d{10}$/.test(nequiNumber)) {
      setError('Ingresa un número de Nequi válido (10 dígitos)');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const res = await authService.updateNequiNumber(nequiNumber);
      setNequiNumber(res?.data?.nequiNumber || nequiNumber);
      setSavedAt(Date.now());
      setTimeout(() => setSavedAt(null), 2500);
    } catch (err) {
      debugError('Error actualizando número de Nequi:', err);
      setError(err?.response?.data?.message || 'No se pudo actualizar tu número de Nequi.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 max-w-xl">
      <div className="flex items-center gap-3 mb-4">
        <Smartphone className="h-6 w-6 text-primary-600" />
        <h3 className="text-lg font-bold text-gray-800">Número de Nequi (para recibir tus pagos)</h3>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-gray-500">
          <Loader className="h-4 w-4 animate-spin" /> Cargando...
        </div>
      ) : (
        <>
          <p className="text-sm text-gray-500 mb-3">
            Aquí recibirás el pago neto de cada consulta. Debe ser un número Nequi a tu nombre (10 dígitos).
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="tel"
              inputMode="numeric"
              value={nequiNumber}
              onChange={handleChange}
              disabled={saving}
              placeholder="3001234567"
              className="input-field flex-1"
            />
            <button
              type="button"
              onClick={handleSave}
              disabled={saving}
              className="btn-primary flex items-center justify-center"
            >
              {saving ? <Loader className="h-4 w-4 animate-spin" /> : 'Guardar'}
            </button>
          </div>

          <div className="mt-3 min-h-[20px] text-sm">
            {!saving && savedAt && (
              <span className="text-green-600 inline-flex items-center gap-1">
                <Check className="h-4 w-4" /> Número guardado
              </span>
            )}
            {error && <span className="text-red-600">{error}</span>}
          </div>
        </>
      )}
    </div>
  );
}

export default NequiEditor;
